/* eslint-disable react/prop-types */
import React, { useState } from 'react'
import { Box } from '@mui/material'
import { Launch } from '@mui/icons-material'
import ModalContainer from '../../Modals/ModalContainer'
import DataTable from '../../@Common/DataTable'
import StyledLink from '../../StyledLink'

function LinkedOffersModal({
  onClickCancel,
  linkedOffers,
}) {
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 5,
    page: 0,
  })

  return (
    <ModalContainer
      processing={false}
      title="Linked Offers"
      maxWidth="sm"
      fullWidth="true"
      hideModal={() => { }}
      actions={{ secondaryAction: { label: 'Cancel', onClick: onClickCancel } }}
    >
      <Box>
        <DataTable
          disableColumnFilter
          paginationMode="client"
          pagination={linkedOffers.length > 5}
          rowsPerPageOptions={[5, 10]}
          pageSizeOptions={[5, 10]}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          disableRowSelectionOnClick
          rows={linkedOffers || []}
          rowCount={linkedOffers ? linkedOffers.length : 0}
          getRowId={(row) => row.offerId}
          columns={[
            {
              field: 'name',
              headerName: 'Offer Name',
              type: 'string',
              width: 250,
              filterable: false,
            },
            {
              field: 'listingId',
              headerName: '',
              type: 'string',
              width: 250,
              align: 'left',
              renderCell: (row) => (
                <Box alignItems="center" display="flex" flexWrap="wrap">
                  <Box display="inline"><Launch style={{ color: '#0E5777' }} /></Box>
                  <Box display="inline" style={{ marginLeft: '5px' }}>
                    <StyledLink
                      onClick={() => onClickCancel()}
                      to={`/partners/listings/${row.row.listingId}/offers/offers`}
                      contents="View Linked Offer"
                    />
                  </Box>

                </Box>
              ),
            },
          ]}
        />
      </Box>
    </ModalContainer>
  )
}

export default LinkedOffersModal
